import {
    temAcesso
} from '@/shared/auth/temAcesso'

// const Entrega = () => import('./Entrega.vue')

export default {
    path: 'entregas',
    name: 'Uabs_Entregas',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    beforeEnter: (to, from, next) => {
        if (temAcesso('CRED-UABS-ENTR-00')) {
            next()
        }
    }
    // ,
    // children: [{
    //     path: ':entregaId',
    //     name: 'Uabs_Entregas_Detalhar',
    //     component: Entrega,
    //     beforeEnter: (to, from, next) => {
    //         if (temAcesso('CRED-UABS-ENTR-01')) {
    //             next()
    //         }
    //     }
    // }]
}
